import {
  FETCH,
  FETCHING,
  FETCHED,
  FETCH_FAIL,
  RECEIVE,
  CREATE,
  CREATING,
  CREATED,
  CREATE_FAIL,
  UPDATE,
  UPDATING,
  UPDATED,
  UPDATE_FAIL,
  DELETE,
  DELETING,
  DELETED,
  DELETE_FAIL,
} from './constants'

// Local
function composer ({model: someName}) {
  const model = `${someName}`.toUpperCase()

  return function ({type}) {
    const actionType = `@@ctrl/${type}${model}`

    return function () {
      return actionType
    }
  }
}

export default function (state) {
  const actionTypes = {}

  const compose = composer({model: state.get().model})

  actionTypes['receive'] = compose({type: RECEIVE})
  const permissions = state.permissions()

  if (permissions['create']) {
    actionTypes['create'] = compose({type: CREATE})
    actionTypes['creating'] = compose({type: CREATING})
    actionTypes['created'] = compose({type: CREATED})
    actionTypes['failCreate'] = compose({type: CREATE_FAIL})
  }

  if (permissions['read']) {
    actionTypes['fetch'] = compose({type: FETCH})
    actionTypes['fetching'] = compose({type: FETCHING})
    actionTypes['fetched'] = compose({type: FETCHED})
    actionTypes['failFetch'] = compose({type: FETCH_FAIL})
  }

  if (permissions['update']) {
    actionTypes['update'] = compose({type: UPDATE})
    actionTypes['updating'] = compose({type: UPDATING})
    actionTypes['updated'] = compose({type: UPDATED})
    actionTypes['failUpdate'] = compose({type: UPDATE_FAIL})
  }

  if (permissions['delete']) {
    actionTypes['delete'] = compose({type: DELETE})
    actionTypes['deleting'] = compose({type: DELETING})
    actionTypes['deleted'] = compose({type: DELETED})
    actionTypes['failDelete'] = compose({type: DELETE_FAIL})
  }

  return {
    ...actionTypes,
    compose,
  }
}
